/* eslint-disable no-shadow */
import moment from "moment";
import systemapi from "@/service/system"
const state = {
  company: "",
  companyname: "",
  systemparmse: {},
  CompanyImage: "LOGO.ae1aaf32.png",
  codemyself: false
};
const getters = {

}
const actions = {
  async getcompany({
    commit,
    state
  }, data) {
    if (state.company) {
      console.log("I got a company name for " + state.company);
    } else {
      try {
        const check = await systemapi.checkCompany(data);
        commit("setCompany", check.data.result);
      } catch (error) {
        console.log("get company error");
      }
    };
    return state;
  },

};

const mutations = {
  setCompany(state, data) {
    state.codemyself = data.codemyself;
    state.company = data.company;
    state.companyname = data.companyname;
    state.CompanyImage = data.companyimage;
    state.systemparmse = data.systemparmse;
    // process.env.VUE_APP_TITLE = state.companyname;
    // console.log(process.env,data);
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
